<template>
        <section class="bottom-select-menu">
            <!-- 战术指令 -->
            <transition name="bottom-menu-upIn" @after-leave="afterLeave">
                <div class="panel-wrapper bottom"
                     v-show="selectCurrent == 1"
                >
                    <aside v-if="isCaptain">
                        <div class="panel-head">
                            <div class="panel-h2">
                                <div class="panel-h2-inner">
                                    <div class="panel-h2-text">
                                        <i class="fa fa-flag"></i>
                                        {{ tacticData.tactic_name ? tacticData.tactic_name : '战术指令' }}
                                    </div>
                                    <em>{{ tacticText }}</em>
                                </div>
                            </div>
                            <span class="close" @click="closePanel"><i class="fa fa-remove"></i></span>
                        </div>
                        <div class="panel-container">
                            <double-scroll :tacticData="tacticData"
                                           :infos="infos"
                                           @selectedTactic="selectedTactic"
                            ></double-scroll>
                        </div>
                    </aside>
                    <aside v-else>
                        <div class="panel-head">
                            <div class="panel-h2">
                                <div class="panel-h2-inner">
                                    <div class="panel-h2-text">
                                        <i class="fa fa-flag"></i>
                                        战术指令
                                    </div>
                                </div>
                            </div>
                            <span class="close" @click="closePanel"><i class="fa fa-remove"></i></span>
                        </div>
                        <div class="panel-container">
                            <div class="no-captain-tips">
                                <p>抱歉，您目前不是队长，无法发起战术</p>
                                <button type="button" class="captain-apply" @click="applyCaptain">队长申请</button>
                            </div>
                        </div>
                    </aside>
                </div>
            </transition>
            <!-- 战术指令 end -->
            <!--  状态切换  -->
            <transition name="bottom-menu-upIn" @after-leave="afterLeave">
                <div class="panel-wrapper bottom"
                     v-show="selectCurrent == 2"
                >
                    <div class="panel-head">
                        <div class="panel-h2">
                            <div class="panel-h2-inner">
                                <div class="panel-h2-text">
                                    <i class="fa fa-retweet"></i>
                                    状态变更
                                </div>
                            </div>
                        </div>
                        <span class="close" @click="closePanel"><i class="fa fa-remove"></i></span>
                    </div>
                    <div class="panel-container">
                        <change-status :infos="infos"
                                       :isCaptain="isCaptain"
                                       :captain="captain"
                                       :myStatus="myStatus"
                        ></change-status>
                    </div>
                </div>
            </transition>
            <!--  状态切换 end -->
            <!--   手动输入    -->
            <transition name="bottom-menu-downIn" @after-leave="afterLeave">
                <div class="panel-wrapper top"
                     v-show="selectCurrent == 3"
                >
                    <div class="panel-head">
                        <div class="panel-h2">
                            <div class="panel-h2-inner">
                                <div class="panel-h2-text">
                                    <i class="fa fa-pencil-square"></i>
                                    手动输入
                                </div>
                            </div>
                        </div>
                        <span class="close" @click="closePanel"><i class="fa fa-remove"></i></span>
                    </div>
                    <div class="panel-container">
                        <textarea-box :selectCurrent="selectCurrent" @closePanel="closePanel"></textarea-box>
                    </div>
                </div>
            </transition>
            <!--   手动输入 end    -->
            <!--  快捷发言   -->
            <transition name="bottom-menu-upIn" @after-leave="afterLeave">
                <div class="panel-wrapper bottom"
                     v-show="selectCurrent == 4"
                >
                    <div class="panel-head">
                        <div class="panel-h2">
                            <div class="panel-h2-inner">
                                <div class="panel-h2-text">
                                    <i class="fa fa-comments"></i>
                                    快捷发言
                                </div>
                            </div>
                        </div>
                        <span class="close" @click="closePanel"><i class="fa fa-remove"></i></span>
                    </div>
                    <div class="panel-container">
                        <quick-say-menu :quickData="quickData"></quick-say-menu>
                    </div>
                </div>
            </transition>
            <!--  快捷发言 end  -->
        </section>

</template>

<script>
    import DoubleScroll from '@/components/double-scroll/double-scroll';
    import QuickSayMenu from '@/components/quick-say-menu/quick-say-menu';
    import TextareaBox from '@/components/textarea-box/textarea-box';
    import ChangeStatus from '@/components/change-status/change-status';
    import { STATUS } from "@/common/const";

    import { postSay } from "@/api/post";
    import { getSayHTML } from "@/common/fns";

    export default {
        name: "bottom-select-menu",
        emits: [ 'afterTransitionEnd', 'close' ],
        props: {
            infos: {
                type: Array,
                default() {
                    return [];
                }
            },
            selectCurrent: {
                type: Number,
                default() {
                    return -1;
                }
            },
            tacticData: {
                type: Object,
                default() {
                    return {};
                }
            },
            quickData: {
                type: Object,
                default() {
                    return {};
                }
            },
            isCaptain: {
                type: Boolean,
                default() {
                    return false;
                }
            },
            captain: {
                type: String,
                default() {
                    return 'nobody'
                }
            },
            myStatus: {
                type: Number,
                default() {
                    return STATUS.outline
                }
            }
        },
        data() {
            return {
                tacticText: ''
            }
        },
        computed: {

        },
        methods: {
            afterLeave() {
                this.$emit('afterTransitionEnd');
            },
            closePanel() {
                this.$emit('close');
            },
            selectedTactic(text) {
                this.tacticText = text;
            },
            async applyCaptain() {
                const myname = window.setting.userInfo.username;
                const applyHtml = getSayHTML.applyCaptain('请给我队长');
                const res = await postSay(myname, applyHtml);
                console.log(res)
            }
        },
        watch: {

        },
        components: {
            DoubleScroll,
            QuickSayMenu,
            TextareaBox,
            ChangeStatus
        }
    }
</script>

<style scoped>
    .bottom-menu-upIn-enter-active,
    .bottom-menu-upIn-leave-active {
        transition: all 0.3s ease;
    }

    .bottom-menu-upIn-enter-from,
    .bottom-menu-upIn-leave-to {
        transform: translate3d(0%, 100%, 0);
        opacity: 0;
    }

    .bottom-menu-downIn-enter-active,
    .bottom-menu-downIn-leave-active {
        transition: all 0.3s ease;
    }

    .bottom-menu-downIn-enter-from,
    .bottom-menu-downIn-leave-to {
        transform: translate3d(0%, -100%, 0);
        opacity: 0;
    }
</style>
